import React from 'react'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import styled from 'particles/themes/styled'
import SignUpAndReset from './SignUpAndReset'
import RegisterSetup from './RegisterSetup'
import Login from './Login/LoginForm'
import SignUpBg from 'icons/SignUpBg.svg'
import LoginBg from 'icons/LoginBg.svg'
import Header from 'components/Shared/Header'

type AuthContainerProps = {
    isRegisterProfileSetup: boolean
    isLogin: boolean
}

const AuthContainer = styled.div<AuthContainerProps>`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 48px;
    height: 100%;
    background-image: ${({ isRegisterProfileSetup, isLogin }) =>
        isRegisterProfileSetup ? 'none' : isLogin ? `url(${LoginBg})` : `url(${SignUpBg})`};
    background-repeat: no-repeat;
    background-position: center bottom;
    background-color: ${({ theme, isRegisterProfileSetup }) =>
        isRegisterProfileSetup ? theme.colors.surface.primary : theme.colors.surface.actionPastelHover};
    align-items: center;
    gap: ${({ theme }) => theme.spacing[900]};
    @media screen and (max-width: 767px) {
        padding: 12px 16px;
        background-image: none;
    }
    .extend-filter {
        margin: 0;
    }
`

const Auth = () => {
    const location = useLocation()
    const params = qs.parse(location.search)
    const { member } = params
    const isRegisterProfileSetup = Boolean(location?.pathname === '/register' && member)
    const isLogin = Boolean(location?.pathname === '/login')

    return (
        <AuthContainer isRegisterProfileSetup={isRegisterProfileSetup} isLogin={isLogin}>
            <Header />
            {isRegisterProfileSetup ? <RegisterSetup /> : isLogin ? <Login /> : <SignUpAndReset />}
        </AuthContainer>
    )
}

export default Auth
